import { Capacitor } from '@capacitor/core'

export const AUTH_CALLBACK_PATH = '/auth/callback'
export const NATIVE_AUTH_SCHEME = 'com.optioneer.app'
export const NATIVE_AUTH_CALLBACK_URL = `${NATIVE_AUTH_SCHEME}://auth/callback`

export function isNativeAuthRedirect() {
  return Capacitor.isNativePlatform()
}

export function getAuthCallbackRedirectTo() {
  if (isNativeAuthRedirect()) {
    return NATIVE_AUTH_CALLBACK_URL
  }

  return `${window.location.origin}${AUTH_CALLBACK_PATH}`
}
